<template>
  <form-field
      :validation-errors="validationErrors"
      :label-for="labelFor"
      :help-text="helpText"
  >
    <!-- https://buefy.org/documentation/checkbox  -->
    <b-checkbox
        v-if="display"
        v-bind="$attrs"
        :value="status"
        :false-value="statusEnum.unChecked.key"
        :true-value="statusEnum.checked.key"
        :indeterminate="isIndeterminate"
        @input="handleInput"
        :size="size"
    >
      <strong v-if="labelIsBold">{{ label }}</strong>
      <template v-else>{{ label }}</template>
      <span v-if="secondaryLabel" class="help-text">{{ secondaryLabel }}</span>
    </b-checkbox>
  </form-field>
</template>
<script>
import FormField from "./FormField";
import {FormFieldMixin} from "./FormField.mixin";
export default {
  name: "FormFieldCheckbox",
  components: {FormField},
  mixins: [FormFieldMixin],
  props: {
    value: {},
    nativeValue: {},
    label: {
      type: String,
    },
    secondaryLabel: {
      type: String,
    },
    labelIsBold: {
      type: Boolean,
      default: false
    },
    labelFor: {
      type: String,
    },
    validationErrors: {
      type: [String, Array, undefined],
    },
    helpText: {
      type: String
    },
    checkedValue: {
      default: true,
    },
    unCheckedValue: {
      default: false,
    },
    indeterminateValue: {
      default: undefined
    },
    watchValue: {},
    size: {
      type: String,
    }
  },
  data() {
    return {
      display: true,
      statusEnum: {
        checked: {
          key: 1,
          value: this.checkedValue,
        },
        unChecked: {
          key: 2,
          value: this.unCheckedValue,
        },
        indeterminate: {
          key: 3,
          value: this.indeterminateValue,
        },
      },
      status: 1,
    };
  },
  watch: {
    value(value) {
      this.setStatus(value);
    },
    watchValue() {
      this.setStatus(this.value);
    }
  },
  mounted() {
    // Make sure to set the type when its ready
    this.setStatus(this.value);
  },
  computed: {
    isIndeterminate() {
      return this.status === this.statusEnum.indeterminate.key;
    },
    indeterminatePresent() {
      return this.statusEnum.indeterminate.value !== undefined;
    },
  },
  methods: {
    setStatus(value) {
      this.display = false;

      if (value === this.checkedValue) {
        this.status = this.statusEnum.checked.key;
      } else if (value === this.unCheckedValue) {
        this.status = this.statusEnum.unChecked.key;
      } else if (value === this.indeterminateValue) {
        this.status = this.statusEnum.indeterminate.key;
      }

      // This is here because bufey is stupid and will now allow you to toggle seamlessly threw the indeerminate values
      this.$nextTick(() => this.display = true);
    },
    handleInput(val) {
      if (this.status === this.statusEnum.unChecked.key) {
        val = this.statusEnum.checked.value;
      } else if (this.status === this.statusEnum.checked.key) {
        // Skip Indeterminate if the is not present
        if (this.indeterminatePresent) {
          val = this.statusEnum.indeterminate.value;
        } else {
          val = this.statusEnum.unChecked.value;
        }
      } else if (this.status === this.statusEnum.indeterminate.key) {
        val = this.statusEnum.unChecked.value;
      }

      this.setStatus(val);

      // return;
      this.$emit('input', val);
      this.$emit('change', val);
      this.$emit('selected', val);
      this.emitGlobalFieldChangeEvent();
    },
  }
}
</script>
<style lang="scss" scoped>
// Due to how Buefy works these styles must be in global styles

.help-text {
  display: block;
  font-size: 80%;
}
</style>
